import { BieLoadSessionStateCode } from './bieloadsession.models';
import {
  IBieOnboardingReviewValidateResult,
  IBieOnboardingReviewValidationResult,
} from './bieonboardingreview.models';
import { BieRecordId, IBieOnboardingWorkbench } from './bieonboardingworkbench.models';
// import {
//   normalizeBieOnboardingResolutionResult,
//   normalizeBieOnboardingValidationResult,
// } from './bieonboardingworkbench.normalizers';
//import { normalizeBieOnboardingWorkbench } from './bieonboardingworkbench.normalizers';

// const objectValue = (value: any): Record<string, any> =>
//   value && typeof value === 'object' && !Array.isArray(value) ? value : {};

const objectValue = (value: any): Record<string, any> =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {};

const numberValue = (value: any): number => {
  const result = Number(value);
  return Number.isFinite(result) ? result : 0;
};

const booleanValue = (value: any): boolean =>
  value === true || value === 1 || value === '1' || value === 'true';

const stringValue = (value: any): string =>
  value === undefined || value === null ? '' : String(value);


export function normalizeBieOnboardingReviewValidationResult(
  value: any,
): IBieOnboardingReviewValidationResult {
  const data = objectValue(value);

  return {
    loadSessionId: numberValue(
      data.loadSessionId ?? data.loadsessionid ?? data.rid,
    ) as BieRecordId,

    previousState: stringValue(
      data.previousState ?? data.previousstate,
    ) as BieLoadSessionStateCode,

    state: stringValue(
      data.state ?? data.stateCode ?? data.statecode,
    ) as BieLoadSessionStateCode,

    valid: booleanValue(data.valid),

    validItems: numberValue(data.validItems ?? data.validitems),
    warningItems: numberValue(data.warningItems ?? data.warningitems),
    failedItems: numberValue(data.failedItems ?? data.faileditems),

    issueCount: numberValue(data.issueCount ?? data.issuecount),
    blockingIssueCount: numberValue(
      data.blockingIssueCount ?? data.blockingissuecount,
    ),

    validatedAt: stringValue(data.validatedAt ?? data.validatedat),
    stamp: stringValue(data.stamp ?? data.stp),
    message: stringValue(data.message),
  };
}

export function normalizeBieOnboardingWorkbench(
  value: any
): IBieOnboardingWorkbench {
  return value as IBieOnboardingWorkbench;
}

export function normalizeBieOnboardingReviewValidateResult(
  value: any,
): IBieOnboardingReviewValidateResult {
  const envelope = objectValue(value);
  const data = objectValue(envelope.sd ?? envelope);

  return {
    validation: normalizeBieOnboardingReviewValidationResult(data.validation),
    workbench: normalizeBieOnboardingWorkbench(data.workbench),
  };
}
